
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { EnumEmptyStatus, EnumEmptyDefultMessage } from '@xt/client/utils/empty-status/index'

@Component({
  components: {}
})
export default class EmptyStatus extends Vue {
  @Prop() type: EnumEmptyStatus
  @Prop() message: string
  @Prop() className: string
  @Prop() marginTop: number
  @Prop() marginBottom: number
  @Prop({ default: false }) showBackButton: boolean
  // 隐藏状态图片，默认为false即不隐藏
  @Prop({ default: false, type: Boolean }) hideImage: boolean
  @Prop() paddingTop: number
  @Prop() paddingBottom: number

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get emptyStatus() {
    return {
      ...(this.marginTop && { marginTop: `${this.marginTop}px` }),
      ...(this.marginBottom && { marginBottom: `${this.marginBottom}px` }),
      ...(this.paddingTop && { paddingTop: `${this.paddingTop}px` }),
      ...(this.paddingBottom && { paddingBottom: `${this.paddingBottom}px` })
    }
  }

  get tipLabel() {
    return this.message ? this.message : EnumEmptyDefultMessage[EnumEmptyStatus[this.type]]
  }

  get homePage() {
    // @ts-expect-error
    return ['index'].includes(this.$route.name?.replace(/-(index)/g, ''))
  }

  goHome() {
    if (this.homePage) {
      window.location.reload()
    } else {
      this.$router.replace({
        path: '/'
      })
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
